import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AiChat from './components/AiChat';
import './i18n/config'; // Initialize i18n

import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'skills', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const sectionTop = element.offsetTop;
          const sectionHeight = element.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    // Initial check
    handleScroll();

    // Add event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll, { passive: true });
    };
  }, [setActiveSection]); // Added setActiveSection to dependencies

  return (
    <ThemeProvider>
      <div
        className="font-sans transition-colors duration-200"
        style={{backgroundColor: 'var(--background)', color: 'var(--foreground)'}}
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
      >
        <Navbar activeSection={activeSection} />
        <main>
          <Hero id="home" />
          <About id="about" />
          <Skills id="skills" />
          <Projects id="projects" />
          <Contact id="contact" />
        </main>
        <Footer />
        <AiChat />
      </div>
    </ThemeProvider>
  );
}

export default App;
